import type { RouteRecordRaw } from 'vue-router';

export const vehiclesRoutes: RouteRecordRaw[] = [
  {
    path: 'vehicles',
    name: 'vehicles',
    component: () => import('./pages/VehiclesListPage.vue'),
    meta: { title: 'Vehicles', requiresAuth: true, permission: 'view_vehicles' },
  },
  {
    path: 'vehicles/new',
    name: 'vehicles.create',
    component: () => import('./pages/VehicleFormPage.vue'),
    meta: { title: 'New vehicle', requiresAuth: true, permission: 'create_vehicles' },
  },
  // Static segment before the `:id` wildcard.
  {
    path: 'vehicles/:id/edit',
    name: 'vehicles.edit',
    component: () => import('./pages/VehicleFormPage.vue'),
    meta: { title: 'Edit vehicle', requiresAuth: true, permission: 'update_vehicles' },
  },
  {
    path: 'vehicles/:id',
    name: 'vehicles.show',
    component: () => import('./pages/VehicleDetailPage.vue'),
    meta: { title: 'Vehicle', requiresAuth: true, permission: 'view_vehicles' },
  },
];
